import { BillingInfoFragmentFragment, GetOrganizationQuery, GetUserQuery } from 'data/__generated__';
import type { TotemEnv } from '../../../../types/totem-env';

export interface InvoiceValues {
    invoiceEmail: string;
    invoiceCity: string;
    invoiceAddress: string;
    invoiceCountry: string;
    invoiceZipcode: string;
    invoiceName: string;
    invoiceVAT: string;
    invoiceSiret: string;
    invoicePO: string;
}

export const getStripeApiKey = (organization: GetOrganizationQuery['organizationOfUser'] | null): string => {
    const env = window.__TOTENV__ as TotemEnv;
    const isProd = env.ENV === 'prod';

    return (
        (!isProd || organization?.isTest ? env?.STRIPE_PUBLISH_API_TEST_KEY : env?.STRIPE_PUBLISH_API_LIVE_KEY) ?? ''
    );
};

export const getBillingDetails = ({
    cardName,
    billingInfo,
    user,
}: {
    cardName: string | undefined | null;
    billingInfo: BillingInfoFragmentFragment | null;
    user: GetUserQuery['user'] | null;
}) => {
    return {
        name: cardName ?? '',
        address: {
            line1: billingInfo?.invoiceAddress || 'address was not provided by user',
            city: billingInfo?.invoiceCity || 'Paris',
            country: 'FR',
        },
        phone: user?.profile?.phone || '+33600000000',
        email: billingInfo?.invoiceEmail || 'email@notprovided.com',
    };
};

export const setInvoiceInitialValues = (billingInfo: BillingInfoFragmentFragment | null): InvoiceValues => {
    return {
        invoiceEmail: billingInfo?.invoiceEmail || '',
        invoiceCity: billingInfo?.invoiceCity || '',
        invoiceAddress: billingInfo?.invoiceAddress || '',
        invoiceCountry: billingInfo?.invoiceCountry || '',
        invoiceZipcode: billingInfo?.invoiceZipcode || '',
        invoiceName: billingInfo?.invoiceName || '',
        invoiceVAT: billingInfo?.invoiceVAT || '',
        invoiceSiret: billingInfo?.invoiceSiret || '',
        invoicePO: billingInfo?.invoicePO || '',
    };
};

export const sumObjectValues = <T>(items: T[], callback: (item: T) => number): number =>
    items.reduce((sum, item) => (sum += callback(item)), 0);
